module.exports = {
  no: 'Norge'
}
